/* eslint-disable @typescript-eslint/ban-types */
import React, { useState } from 'react';
import { Cell, ColumnInterface } from 'react-table';
import { Color } from '@amcharts/amcharts4/core';
import { LineSeries } from '@amcharts/amcharts4/charts';
import cx from 'classnames';

import { legendSizes, squareBulletWidth } from '../constants';

interface Props {
    cell: Cell<QRRLegendTableItem>;
    column: ColumnInterface<QRRLegendTableItem>;
}

/**
 * Shows the name of an entity, along with a color-coded square that matches the color of the
 * corresponding line in the QuarterlyRunRate chart. The square is sized to match the square bullet
 * at the end of each line.
 * @param props - {@link Props}
 */
export function EntityNameCell({ cell, column }: Props): JSX.Element {
    const width = (column?.width as number) ?? legendSizes.defaultCellWidth;
    const entityName: string | null = cell?.value?.entityName ?? null;
    const color: Color | null = cell?.value?.color ?? null;
    const series: LineSeries | null = cell?.value?.series ?? null;

    const [hidden, setHidden] = useState(
        !series?.visible ?? (true || series?.isHiding) ?? false,
    );

    if (entityName === null || entityName.length === 0) {
        // unicode em dash
        return <>&#8212;</>;
    }

    return (
        <button
            type="button"
            className="respond-to-mouse px-1 grid"
            style={{
                width,
                gridTemplateColumns: '14px auto',
            }}
            onClick={() => {
                if (series !== null) {
                    if (!series.visible || series.isHiding) {
                        if (series.hidden === true) {
                            series.hidden = false;
                        }

                        if (series.show) {
                            series.show();
                        } else {
                            series.visible = true;
                        }
                        setHidden(false);
                    } else if (series.hide) {
                        series.hide();
                        setHidden(true);
                    } else {
                        series.visible = false;
                        setHidden(true);
                    }
                }
            }}
        >
            <div
                className={cx('mt-1 mr-2', {
                    'border border-tertiary-300': hidden,
                })}
                style={{
                    backgroundColor: hidden ? undefined : color?.hex,
                    height: squareBulletWidth,
                    width: squareBulletWidth,
                }}
            />
            <div className="clamp-2-lines-break-words text-xs text-left">
                {entityName}
            </div>
        </button>
    );
}
